
<div class="reception-item-select__wrapper">
  <span class="reception-item-select__title">受付項目</span>
  <select
    class="reception-item-select__select js-reception-item-select"
    @change="onChangeReceptionItem"
  >
    <template v-for="receptionItem in receptionItems">
      <option
        v-if="receptionItem.isDeleted == 0"
        :key="receptionItem.hospitalId"
        :value="receptionItem.hospitalId"
        :selected="receptionItem.hospitalId == selectedReceptionItemId"
      >
        {{ receptionItem | receptionItemNameWithPrefix }}
      </option>
    </template>
  </select>
  <span class="fa fa-chevron-down reception-item-select__chevron-down-icon"></span>
</div>
